import Axios from "axios";
import { useContext, useEffect, useState } from "react";
import { Button, Col, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import DashboardContext from "../../../Context";
import { useHistory } from "react-router-dom";

/**
 * این کامپوننت برای نمایش مدال کنسل کردن سفارش است
 * این مدال در جدول سفارشات استفاده شده است
 */
const ModalCancel = ({
  showitem,
  handleCloseMoudal,
  id,
  handeldeleteitem,
  access = "",
}) => {
  const { location } = useHistory();
  const [loading, setLoading] = useState(false);

  const [dataForm, setDataForm] = useState({ id });

  const { urldashboard, authentication, urlPatch } =
    useContext(DashboardContext);

  const [controllerName, setControllerName] = useState(
    location.pathname.split("/")[1].replace("/", "")
  );

  const sendData = async () => {
    try {
      const res =
        access === "/PeriodOrder"
          ? await Axios.post(
              `${urldashboard}/periodorder/cancel `,
              JSON.stringify(dataForm),
              {
                headers: {
                  Authorization: authentication,
                  "content-type": "application/json; charset=utf-8",
                },
              }
            )
          : access === "/BusinessToBusinessPeriodOrder"
          ? await Axios.post(
              `${urldashboard}/businessToBusinessPeriodOrder/cancel `,
              JSON.stringify(dataForm),
              {
                headers: {
                  Authorization: authentication,
                  "content-type": "application/json; charset=utf-8",
                },
              }
            )
          : await Axios.put(
              `${urldashboard}/${controllerName}/cancel`,
              JSON.stringify(dataForm),
              {
                headers: {
                  Authorization: authentication,
                  "content-type": "application/json; charset=utf-8",
                },
              }
            );

      const data = await res.data;
      toast.success(data.message, {
        position: "bottom-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      setLoading(false);
      if (handeldeleteitem) handeldeleteitem();
      handleCloseMoudal();
    } catch (error) {
      if (error.message === "Network Error") {
        toast.error("اینترنت قطع است لطفا وضعیت اینترنت را بررسی کنید:(", {
          position: "bottom-left",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        setLoading(false);
      } else {
        console.log(error);
        setLoading(false);
        toast.error(error.response.data.message, {
          position: "bottom-left",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    }
  };

  useEffect(() => {
    if (location.pathname.includes("Customer")) {
      setControllerName("order");
    }
  }, []);

  const handelsubmit = () => {
    setLoading(true);

    if (!dataForm.description) {
      toast.error("لطفا توضیحات وارد کنید", {
        position: "bottom-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });

      setLoading(false);
    } else {
      sendData();
    }
  };
  return (
    <Modal show={showitem} onHide={handleCloseMoudal}>
      <Modal.Header>
        <Modal.Title>کنسل کردن سفارش</Modal.Title>
        <i
          className='fa fa-times mr-auto'
          style={{ fontSize: "16px", cursor: "pointer" }}
          onClick={handleCloseMoudal}
          aria-hidden='true'
        ></i>
      </Modal.Header>
      <Modal.Body>
        <Col lg='12' md='12' sm='12' xs='12'>
          <div className='form-group'>
            <label htmlFor='descriptionTextarea'>توضیحات</label>
            <textarea
              className='form-control'
              id='descriptionTextarea'
              rows='6'
              defaultValue={dataForm.description}
              onChange={(e) =>
                setDataForm({ ...dataForm, description: e.target.value })
              }
            ></textarea>

            <div>
              آیا sms ارسال شود؟{" "}
              <input
                style={{ marginTop: 15, width: 20, height: 20 }}
                type='checkbox'
                onChange={(e) => {
                  setDataForm({ ...dataForm, sendSms: e.target.checked });
                }}
                name='name'
              />
            </div>
          </div>
        </Col>
      </Modal.Body>
      <Modal.Footer>
        <Button variant='danger' disabled={loading} onClick={handleCloseMoudal}>
          بستن
        </Button>
        <Button variant='success' disabled={loading} onClick={handelsubmit}>
          {loading ? (
            <i className='fa fa-spinner fa-pulse fa-fw'></i>
          ) : (
            "تایید لغو"
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalCancel;
